<template>
  <div style="display: flex; flex-direction: column; height: 100vh">
    <div class="container">
      <div class="popup_header1">
        <b-button  class="back_btn" @click="$router.back()" variant="white">
          <b-img :src="require('../../../../assets/image/ic_back.png')"/>
        </b-button>
        <div style="margin: auto" class="popup_title">{{$t("more.inquire")}}</div>
      </div>
    </div>
    <div style="height: 100%; overflow: auto" class="container">
      <InquireItem
        v-for="(item, i) in dataList"
        :key="i"
        :item="item"
        variant="user"
        itemType="inquire"
        @click="onDetail(item)"
      >
      </InquireItem>
    </div>
      <SearchForm
        class="container"
        variant="inquire"
        :searchValue.sync="keyword"
        :searchType.sync="searchType"
        :mine.sync="mine"
        :count="pageCnt"
        @change_page="change_page"
        @search="type_search"
        @make="onCreate"
      ></SearchForm>
    <InquireCreatePopup
      :visible.sync="showCreate"
      :info="InquireSelected"
      :variant="popupVariant"
      @edit="onEdit"
      @add="onEdit"
      @delete="onDelete"
    >
    </InquireCreatePopup>
  </div>
</template>

<script>
import Utils from "../../../../config/utils";
import Navbar from "../../../controls/navbar";
import SearchForm from "../admin/controls/search_form";
import InquireCreatePopup from "../../../controls/popup/InquireCreatePopup";
import InquireItem from "../../../controls/CommunityItem";

export default {
  name: "Inquire",
  components: {
    SearchForm,
    Navbar,
    InquireCreatePopup,
    InquireItem
  },
  data() {
    return {
      tabIndex:0,
      dataList:[],
      pageCnt:1,
      totalCnt:1,
      limit:0,
      mine:false,
      searchType:null,
      keyword:null,
      currentPage:1,
      InquireSelected:null,
      showDetail:false,
      showCreate:false,
      popupVariant:'detail',
    }
  },
  methods:{
    onDetail(item){
      this.InquireSelected = item;
      if (item.f_secret == 'Y') {
        if(item.f_user_idx != this.myinfo.uid && !this.myinfo.isAdmin()){
          Utils.toast(this, this.$t('inquire.secret_inquire'));
        return;
        }
      }
        if (!this.myinfo.isAdmin() && item.f_user_idx != this.myinfo.uid)
          this.popupVariant = 'detail';
        else
          this.popupVariant = 'create';
        this.showCreate = true;
    },

    onCreate() {
      this.popupVariant = 'create';
      this.InquireSelected = null;
      this.showCreate = true;
    },

    onDelete(){
      this.dataList = this.dataList.filter(it => {
        return it.f_idx != this.InquireSelected.f_idx;
      });
    },

    onEdit(){
      this.getList();
    },

    change_page(page){
      this.currentPage = page;
      this.getList();
    },

    type_search(){
      this.getList();
    },


    initList(){
        this.pageNum = 1;
        this.datalist = [];
        this.getList();
    },


    getList(){
      Utils.requestGet(this.$c.API.Inquire.getInquireList, {
        page_num: this.currentPage,
        column: this.searchType,
        keyword: this.keyword,
        mine: this.mine ? 1 : 0
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.totalCnt  = result.data.total;
          this.pageCnt = result.data.page_count;
          this.limit = result.data.limit;
          this.dataList = result.data.list.map(it => {
            it.f_select = false;
            return it;
          });
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
  },

  computed:{
  },
  watch:{
    mine(){
      this.getList();
    }
  },

  mounted() {
    this.$store.commit('setTabIndex', this.$c.MAIN_TAB.Inquire);
    this.getList();
  }
}
</script>

<style lang="scss">
@import '../../../../assets/css/_vars.scss';
@import '../../../../assets/css/main/more/Inquire.scss';
//.back_btn{
//  position: absolute;
//  left: 0;
//  top: 0;
//  width: 45px;
//  height: 100%;
//  align-items: center;
//  justify-content: center;
//}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/more/Inquire.vue